import { render, staticRenderFns } from "./OrdersListView.vue?vue&type=template&id=9c7a02f8&"
import script from "./OrdersListView.vue?vue&type=script&lang=js&"
export * from "./OrdersListView.vue?vue&type=script&lang=js&"
import style0 from "./OrdersListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports